import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ onOpenModal }) => {
  return (
    <section className="relative min-h-[90vh] flex items-center bg-[#F9F8F6] overflow-hidden pt-16" data-testid="home-hero-section">

      {/* Decorative elements */}
      <div className="absolute top-12 right-[35%] w-40 h-56 bg-[#C85A40] rounded-[50%] rotate-[-25deg] opacity-80 blur-[1px]" />
      <div className="absolute bottom-[30%] left-[42%] w-5 h-5 bg-[#C85A40] rounded-full opacity-70" />
      <div className="absolute top-[20%] left-[5%] w-3 h-3 bg-[#1A3628] rounded-full opacity-30" />
      <div className="absolute bottom-[15%] right-[10%] w-4 h-4 bg-[#1A3628] rounded-full opacity-20" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">

          {/* Left — Text Content */}
          <div className="order-2 lg:order-1">
            <h1 className="font-display text-5xl font-bold text-[#111C16] tracking-tighter leading-[1.05] mb-8">
              Take Your First Step Towards <span className="text-[#C85A40]">Brand Protection</span>
            </h1>
            <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-10 max-w-lg">
              We understand that your brand represents years of effort, trust, and ambition, securing it should never feel confusing or uncertain. Our team provides structured trademark registration support tailored to businesses of every size across multiple jurisdictions.
            </p>
            <button
              onClick={() => onOpenModal?.('Hero - Get Started')}
              className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-10 py-5 rounded-full transition-all duration-300 hover:scale-[1.02] inline-flex items-center gap-3 shadow-lg shadow-[#C85A40]/20"
              data-testid="home-hero-cta">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                <ArrowRight className="h-4 w-4 text-white" strokeWidth={2} />
              </div>
              Register Your Trademark
            </button>
          </div>

          {/* Right — Full image with curved border */}
          <div className="order-1 lg:order-2 relative flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px]">
              {/* Terracotta curved border behind image */}
              <div className="absolute -inset-3 rounded-[30%_70%_60%_40%/50%_40%_60%_50%] border-[3px] border-[#C85A40] opacity-50" />
              {/* Image container */}
              <div className="rounded-[30%_70%_60%_40%/50%_40%_60%_50%] overflow-hidden">
                <img
                  src="/assets/img/banner-1.webp"
                  alt="Professional attorney holding tablet"
                  className="w-full h-[450px] md:h-[550px] object-cover object-center"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
